import { useTheme } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/system';
import { useLocation } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import { FC, useEffect } from 'react';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { useAppDispatch } from '../hooks/useAppStore';
import { commonActions } from '../store/common/slice';
import { ANIMATION_PATH_MAP, ANIMATION_PATHS } from '../data';

const LoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 99999,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  ...(theme.palette.mode === 'light' && {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  }),
}));

type TLoader = {
  isDashboard?: boolean
};

const Loader: FC<TLoader> = ({ isDashboard = false }) => {
  const location = useLocation();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isMobile) dispatch(commonActions.setToggleDrawer(false));
  }, [isMobile]);

  return (
    <LoaderWrapper>
      {ANIMATION_PATHS?.includes(location.pathname) && isDashboard ? (
        <Player
          src={ANIMATION_PATH_MAP[location.pathname]}
          keepLastFrame
          autoplay
          style={{
            width: isMobile ? 'auto' : 500,
          }}
        />
      ) : <LinearProgress />}
    </LoaderWrapper>
  );
};

export { Loader };
